import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Tabs,
  Tab,
  Button,
  TextField,
  Autocomplete,
  Alert,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMarketPlaces } from "../../../../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../../../../redux/actions/ecommercePlaceActions";
import marketplacesService from "../../../../services/marketplacesService";
import { Chip } from "@mui/material";
import {
  addPlacesCategory,
  fetchPlacesCategory,
  deletePlacesCategory,
} from "../../../../redux/actions/placesCategoryActions";
import axios from "axios";
import outWardService from "../../../../services/outWardService";
import { useNavigate } from "react-router-dom";
import ecommercePlaceService from "../../../../services/ecommercePlaceService";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "98vw", sm: "600px" },
  minWidth: { xs: "98vw", sm: "auto" },
  maxWidth: { xs: "98vw", sm: "90vw" },
  bgcolor: "background.paper",
  boxShadow: 24,
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  height: { xs: "98vh", sm: "500px" },
  minHeight: { xs: "98vh", sm: "auto" },
  borderRadius: 2,
  overflow: "hidden",
  p: 0,
};

const sideMenuStyle = {
  width: { xs: "100%", sm: "35%" },
  borderRight: { xs: "none", sm: "1px solid #ddd" },
  borderBottom: { xs: "1px solid #ddd", sm: "none" },
  display: "flex",
  flexDirection: { xs: "row", sm: "column" },
  justifyContent: "flex-start",
  alignItems: { xs: "center", sm: "stretch" },
  minHeight: { xs: 60, sm: "auto" },
  maxHeight: { xs: 60, sm: "none" },
  overflowX: { xs: "auto", sm: "visible" },
  overflowY: { xs: "hidden", sm: "visible" },
  p: { xs: 1, sm: 0 },
};

const contentStyle = {
  width: "100%",
  padding: { xs: 2, sm: 4 },
  overflowY: "auto",
  flex: 1,
};

const CategoryMatchingModal = ({ open, handleClose, category }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  const [allPlaces, setAllPlaces] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [marketplacecategories, setMarketPlaceCategories] = useState([]);
  const [selectedMarketplaceCategories, setSelectedMarketplaceCategories] =
    useState([]);
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const [autocompleteSelected, setAutocompleteSelected] = useState(null);
  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [accountMarketpleacesName, setAccountMarketpleacesName] = useState({});
  const [selectedTab, setSelectedTab] = useState(() => {
    return parseInt(localStorage.getItem("selectedTab")) || 0;
  });
  const [currentRequestId, setCurrentRequestId] = useState(0);
  useEffect(() => {
    const fetchCategories = async () => {
      if (!category?.id) return;
      try {
        const queryModel = { categoryId: category.id };
        const response = await dispatch(fetchPlacesCategory(queryModel));
        if (response?.data?.length) {
          const groupedCategories = response.data.reduce((acc, item) => {
            const {
              id,
              marketPlaceId,
              marketPlaceCategoryId,
              marketPlaceCategoryName,
              ecommercePlaceId,
            } = item;

            let actualId, type;

            if (marketPlaceId) {
              actualId = marketPlaceId;
              type = "marketplace";
            } else if (ecommercePlaceId) {
              actualId = ecommercePlaceId;
              type = "ecommerce";
            } else {
              console.warn(
                "Hem marketPlaceId hem de ecommercePlaceId tanımsız:",
                item
              );
              return acc;
            }

            // Grubun dizisi var mı?
            if (!acc[actualId]) {
              acc[actualId] = [];
            }

            // Ekleyelim
            acc[actualId].push({
              id: marketPlaceCategoryId,
              name: marketPlaceCategoryName,
              originalId: id,
              type: type,
              marketPlaceId: marketPlaceId,
              ecommercePlaceId: ecommercePlaceId,
            });

            return acc;
          }, {});
          if (
            JSON.stringify(groupedCategories) !==
            JSON.stringify(selectedMarketplaceCategories)
          ) {
            setSelectedMarketplaceCategories(groupedCategories);
          }
        }
      } catch (error) {
        console.error(
          "Kategoriler alınırken hata oluştu:",
          error?.message || "Hata"
        );
      }
    };

    fetchCategories();
  }, [category?.id, dispatch, selectedMarketplaceCategories]);

  // Kaldırıldı: selectedTab değişince marketPlaceCategories'ı (dropdown listesi)
  // selectedMarketplaceCategories ile üzerine yazıyordu; bu OpenCart vb. platformlarda
  // kategorilerin "yok olmasına" neden oluyordu. Dropdown listesi sadece handleTabChange
  // içinde API'den gelen veriyle doldurulmalı.

  useEffect(() => {
    const fetchModalData = async () => {
      if (!open) return;
      setLoading(true);
      try {
        const [accountsResponse, marketRes, ecommerceRes] = await Promise.all([
          marketplacesService.getMarketPlacesAccountsApi(userId, token),
          dispatch(getMarketPlaces(token)),
          dispatch(getEcommercePlaces(token)),
        ]);
        setAllAccounts(accountsResponse?.data?.data?.data);
        const uniqueMarketPlaceNames1 = [
          ...new Set(
            accountsResponse?.data?.data?.data.map(
              (item) => item?.marketPlaceName
            )
          ),
        ];
        const response =
          await ecommercePlaceService.getEcommercePlaceAccountsApi(
            userId,
            token
          );
        const uniqueMarketPlaceNames2 = [
          ...new Set(
            response?.data?.data?.data.map((item) => item?.ecommercePlaceName)
          ),
        ];

        const allUniqueMarketPlaceNames = [
          ...new Set([...uniqueMarketPlaceNames1, ...uniqueMarketPlaceNames2]),
        ];

        setAccountMarketpleacesName(allUniqueMarketPlaceNames);
        setEcommerceAllAccounts(response?.data?.data?.data);
        const combinedData = [
          ...marketRes.data.map((place) => ({ ...place, type: "marketplace" })),
          ...ecommerceRes.data.map((place) => ({
            ...place,
            type: "ecommerce",
          })),
        ];

        setAllPlaces(combinedData);
      } catch (err) {
        setError(
          err?.response?.data?.message ||
            err?.message ||
            "Veriler alınırken hata oluştu."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchModalData();
  }, [open, dispatch, userId, token]);

  useEffect(() => {
    if (open && allPlaces.length > 0) {
      handleTabChange(1, selectedTab);
    }
  }, [open, allPlaces]);

  useEffect(() => {
    if (!open) {
      // Modal kapandığında tüm state'leri temizle ve bekleyen istekleri iptal et
      setMarketPlaceCategories([]);
      setFilteredCategories([]);
      setAutocompleteValue(null);
      setAutocompleteSelected(null);
      setCurrentRequestId(0);
    }
  }, [open]);

  const createRequestBody = (
    selectedPlaceName,
    allAccounts,
    startDate = new Date().toISOString(),
    endDate = new Date().toISOString()
  ) => {
    // Pazaryeri ayarlarını filtrele ve yapılandır
    const marketPlaceSettings = allAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    // e-Ticaret ayarları (manuel olarak tanımlanmış)
    const ecommercePlaceSettings = ecommerceAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    // Nihai istek gövdesini döndür
    return {
      userId: 0,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings,
      startDate,
      endDate,
    };
  };

  const handleTabChange = async (event, newValue) => {
    console.log(newValue);
    
    // Her yeni istek için benzersiz bir ID oluştur
    const requestId = Date.now();
    setCurrentRequestId(requestId);
    
    // State güncellemelerini hemen yap - UI'ı temizle
    setSelectedTab(newValue);
    localStorage.setItem("selectedTab", newValue);
    setAutocompleteValue(null);
    setAutocompleteSelected(null);
    setMarketPlaceCategories([]);
    setFilteredCategories([]);
    setLoadingAutocomplete(true);

    let selectedPlace = allPlaces[newValue];
    let marketPlaceId = selectedPlace?.id;

    if (!selectedPlace) {
      selectedPlace = {
        id: 99999,
        name: "+",
        iconLink: "",
        colorCode: "#3f3f3f",
        type: "marketplace",
      };
      marketPlaceId = 99999;
    }

    if (!marketPlaceId) {
      console.error("Geçerli bir pazaryeri bulunamadı.");
      setLoadingAutocomplete(false);
      return;
    }
    if (marketPlaceId == 99999) {
      setLoadingAutocomplete(false);
      return;
    }

    try {
      const response = await outWardService.fetchCategory(
        selectedPlace.name,
        createRequestBody(selectedPlace.name, allAccounts),
        token
      );

      // Bu istek hala geçerli mi kontrol et (kullanıcı başka tab'a geçmemiş mi?)
      setCurrentRequestId(prevRequestId => {
        if (prevRequestId === requestId) {
          // Bu istek hala geçerli, kategorileri güncelle
          const flattenedCategories = flattenMarketPlaceCategories(response);
          setMarketPlaceCategories(flattenedCategories);
          setLoadingAutocomplete(false);
        } else {
          // Bu istek artık geçersiz, sonucu yok say
          console.log("Eski API yanıtı göz ardı edildi:", selectedPlace.name);
        }
        return prevRequestId;
      });
    } catch (error) {
      // Sadece bu istek hala geçerliyse hata durumunu güncelle
      setCurrentRequestId(prevRequestId => {
        if (prevRequestId === requestId) {
          console.error("API Hatası:", error.response?.data || error.message);
          setMarketPlaceCategories([]);
          setLoadingAutocomplete(false);
        }
        return prevRequestId;
      });
    }
  };

  const flattenMarketPlaceCategories = (
    categories,
    parentPath = [],
    level = 0
  ) => {
    let flatList = [];

    const recurse = (categoryList, currentPath, currentLevel) => {
      for (const category of categoryList) {
        const fullPath = [...currentPath, category.name];
        if (category.name != null) {
          flatList.push({
            id: category.id,
            name: category.name,
            path: fullPath.join(" > "),
            level: currentLevel,
            parents: currentPath,
            categoryPath: category?.categoryPath,
          });
        }

        if (category.categories?.length > 0) {
          recurse(category.categories, fullPath, currentLevel + 1);
        }
      }
    };

    recurse(categories, parentPath, level);

    return flatList;
  };

  const handleAddCategory = async () => {
    const selectedPlace = allPlaces[selectedTab];

    if (!selectedPlace || !autocompleteSelected) {
      console.warn("Seçilen yer veya kategori eksik!");
      return;
    }

    const { type, id: placeId } = selectedPlace;
    const matchingData = {
      Id: 0,
      MarketPlaceId: type === "marketplace" ? placeId : null,
      EcommercePlaceId: type === "ecommerce" ? placeId : null,
      CategoryId: category.id,
      MarketPlaceCategoryId: autocompleteSelected.id,
      MarketPlaceCategoryName: autocompleteSelected.name,
      CreateDate: new Date().toISOString(),
      UpdateDate: new Date().toISOString(),
      IA: true,
    };

    try {
      await dispatch(addPlacesCategory(matchingData, token));

      await refreshModalData();

      setAutocompleteSelected(null);
      setAutocompleteValue(null);
    } catch (error) {
      console.error("Kategori eklenirken hata oluştu:", error.message || error);
    }
  };

  const handleDeleteCategory = async (originalId) => {
    if (!originalId) {
      console.warn("Silinecek kategori ID'si eksik!");
      return;
    }

    try {
      // Kategori silme işlemi
      await dispatch(deletePlacesCategory(originalId, token));

      // Verilerin yenilenmesi

      await refreshModalData();
      handleTabChange(1, selectedTab);
    } catch (error) {
      // Hata durumunda loglama
      console.error(
        "Kategori silinirken hata oluştu:",
        error?.message || error
      );
    }
  };

  const resetModal = () => {
    setAllPlaces([]);
    setAllAccounts([]);
    setMarketPlaceCategories([]);
    setSelectedMarketplaceCategories([]);
    setAutocompleteValue(null);
    setAutocompleteSelected(null);
    setFilteredCategories([]);
    setSelectedTab(0);
    setError(null);
    setLoading(false);
  };

  const handleCloseModal = () => {
    resetModal();
    handleClose();
  };

  const refreshModalData = async () => {
    setLoading(true);

    if (!category?.id) {
      setLoading(false);
      return;
    }

    try {
      setSelectedMarketplaceCategories([]);
      const queryModel = { categoryId: category.id };
      const response = await dispatch(fetchPlacesCategory(queryModel));
      if (response?.data?.length) {
        const groupedCategories = response.data.reduce((acc, item) => {
          const {
            id,
            marketPlaceId,
            marketPlaceCategoryId,
            marketPlaceCategoryName,
            ecommercePlaceId,
          } = item;

          // Hangi ID var?
          // (Eğer ihtiyacınız varsa, "ikisi de var" durumuna ayrı bir if ekleyebilirsiniz.)
          let actualId, type;

          if (marketPlaceId) {
            actualId = marketPlaceId;
            type = "marketplaces";
          } else if (ecommercePlaceId) {
            actualId = ecommercePlaceId;
            type = "ecommerce";
          } else {
            // Hem marketPlaceId hem de ecommercePlaceId eksikse, atlamayı tercih edebilirsiniz
            // ya da loglayabilirsiniz
            console.warn(
              "Hem marketPlaceId hem de ecommercePlaceId tanımsız:",
              item
            );
            return acc;
          }

          // Grubun dizisi var mı?
          if (!acc[actualId]) {
            acc[actualId] = [];
          }

          // Ekleyelim
          acc[actualId].push({
            id: marketPlaceCategoryId,
            name: marketPlaceCategoryName,
            originalId: id,
            type: type,
          });

          return acc;
        }, {});
        setSelectedMarketplaceCategories(groupedCategories);
      }
    } catch (error) {
      console.error(
        "Veriler yenilenirken hata oluştu:",
        error?.message || error
      );
    } finally {
      setLoading(false);
    }
  };

  // Separate Filter Function for Autocomplete
  const filterCategories = (options, state) => {
    const searchTerm = state.inputValue.toLowerCase();
    const matchingOptions = options.filter(
      (option) =>
        option?.name?.toLowerCase()?.includes(searchTerm) ||
        option?.path?.toLowerCase()?.includes(searchTerm)
    );

    const parentIds = new Set();
    matchingOptions.forEach((option) => {
      option?.parents?.forEach((parentName) => {
        const parentOption = options.find((opt) => opt.name === parentName);
        if (parentOption) {
          parentIds.add(parentOption.id);
        }
      });
    });

    var data = options.filter(
      (option) => matchingOptions.includes(option) || parentIds.has(option.id)
    );
    return data.slice(0, 50);
  };

  const filterCategoriesIdefix = (options, state) => {
    const searchTerm = state.inputValue.toLowerCase();
    const matchingOptions = options.filter(
      (option) =>
        option?.name?.toLowerCase()?.includes(searchTerm) ||
        option?.path?.toLowerCase()?.includes(searchTerm)
    );

    const parentIds = new Set();
    matchingOptions.forEach((option) => {
      option?.parents?.forEach((parentName) => {
        const parentOption = options.find((opt) => opt.name === parentName);
        if (parentOption) {
          parentIds.add(parentOption.id);
        }
      });
    });

    var data = options.filter(
      (option) => matchingOptions.includes(option) || parentIds.has(option.id)
    );
    return data.slice(0, 50);
  };

  //ozon için
  const ozonfilterCategories = (options, state) => {
    const searchTerm = state.inputValue.toLowerCase();
    return options
      .filter(
        (option) =>
          option?.name?.toLowerCase()?.includes(searchTerm) ||
          option?.path?.toLowerCase()?.includes(searchTerm)
      )
      .slice(0, 500);
  };
  //ptt için
  const filterCategoriesPtt = (options, state) => {
    const searchTerm = state.inputValue.toLowerCase();
    const matchingOptions = options.filter(
      (option) =>
        option.name.toLowerCase().includes(searchTerm) ||
        option.path.toLowerCase().includes(searchTerm)
    );

    const parentIds = new Set();
    matchingOptions.forEach((option) => {
      option.parents.forEach((parentName) => {
        const parentOption = options.find((opt) => opt.name === parentName);
        if (parentOption) {
          parentIds.add(parentOption.id);
        }
      });
    });

    return options.filter((option) => parentIds.has(option.id));
  };

  const [filteredCategories, setFilteredCategories] = useState([]);

  const handleInputChange = (event, value) => {
    // Kullanıcının arama girişi
    if (value.length > 0) {
      setFilteredCategories([]);
      const filtered = marketplacecategories.filter((category) =>
        category.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCategories(filtered.slice(0, 100));
    } else {
      setFilteredCategories([]);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="category-matching-title"
      aria-describedby="category-matching-description"
    >
      <Box sx={modalStyle}>
        <Box sx={sideMenuStyle}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Tabs
              variant="scrollable"
              orientation={window.innerWidth < 600 ? "horizontal" : "vertical"}
              visibleScrollbar={true}
              value={selectedTab}
              scrollButtons={true}
              allowScrollButtonsMobile={true}
              onChange={handleTabChange}
              aria-label="Kategori Tabs"
              sx={{
                minHeight: { xs: 48, sm: "auto" },
                width: { xs: "100%", sm: "auto" },
                borderBottom: { xs: "none", sm: "none" },
                borderRight: { xs: "none", sm: "1px solid #ddd" },
              }}
            >
              {allPlaces.map((place) => (
                <Tab
                  key={`${place.type}-${place.id}`}
                  label={place.name}
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    minWidth: { xs: 80, sm: 120 },
                    px: { xs: 1, sm: 2 },
                    py: { xs: 1, sm: 2 },
                  }}
                />
              ))}
              <Tab
                key={0}
                label={
                  <span
                    style={{
                      fontSize: window.innerWidth < 600 ? "1.5rem" : "30px",
                      fontWeight: "bold",
                    }}
                  >
                    +
                  </span>
                }
              />
            </Tabs>
          )}
        </Box>

        <Box sx={contentStyle}>
          {loading ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : allPlaces[selectedTab]?.name ? (
            <>
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mb: 3,
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                }}
              >
                {allPlaces[selectedTab]?.name || "Kategori Seç"}
              </Typography>

              {!accountMarketpleacesName.includes(
                allPlaces[selectedTab]?.name
              ) ? (
                <Alert severity="warning" sx={{ width: "100%", mb: 2 }}>
                  Seçilen pazaryeri için ayarlar eksik. Lütfen{" "}
                  <a
                    href="/Profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "blue",
                    }}
                  >
                    profil
                  </a>{" "}
                  alanından gerekli bilgileri doldurunuz.
                </Alert>
              ) : null}

              {category && (
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    mb: 3,
                    textAlign: "center",
                    fontSize: { xs: "0.95rem", sm: "16px" },
                    color: "text.secondary",
                  }}
                >
                  Seçilen Kategori: {category.name}
                </Typography>
              )}
              {!accountMarketpleacesName.includes(
                allPlaces[selectedTab]?.name
              ) ? null : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: { xs: "100%", sm: "400px" },
                      mb: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    {loadingAutocomplete ? (
                      <CircularProgress size={24} />
                    ) : allPlaces[selectedTab]?.name != "Hepsiburada" ? (
                      <Autocomplete
                        options={marketplacecategories}
                        getOptionLabel={(option) => option.name}
                        value={autocompleteValue}
                        onChange={(event, value) => {
                          setAutocompleteValue(value);
                          setAutocompleteSelected(value);
                        }}
                        filterOptions={
                          allPlaces[selectedTab]?.name != "Pttavm" &&
                          allPlaces[selectedTab]?.name != "Ozon" &&
                          allPlaces[selectedTab]?.name != "Idefix"
                            ? filterCategories
                            : allPlaces[selectedTab]?.name == "Ozon"
                            ? ozonfilterCategories
                            : allPlaces[selectedTab]?.name == "Idefix"
                            ? filterCategoriesIdefix
                            : filterCategoriesPtt
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            {...props}
                            sx={{
                              marginLeft: `${option.level * 16}px`,
                            }}
                          >
                            {option.name}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            {...params}
                            label="Kategori Seç"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                        disabled={Boolean(
                          (selectedMarketplaceCategories[
                            allPlaces[selectedTab]?.id
                          ]?.filter(
                            (item) => item.type === allPlaces[selectedTab]?.type
                          )[0]?.ecommercePlaceId ==
                            allPlaces[selectedTab]?.id ||
                            selectedMarketplaceCategories[
                              allPlaces[selectedTab]?.id
                            ]?.filter(
                              (item) =>
                                item.type === allPlaces[selectedTab]?.type
                            )[0]?.marketPlaceId ==
                              allPlaces[selectedTab]?.id) &&
                            allPlaces[selectedTab]?.type ==
                              selectedMarketplaceCategories[
                                allPlaces[selectedTab]?.id
                              ]?.filter(
                                (item) =>
                                  item.type === allPlaces[selectedTab]?.type
                              )[0]?.type
                        )}
                      />
                    ) : (
                      <Autocomplete
                        options={filteredCategories}
                        onChange={(event, value) => {
                          setAutocompleteValue(value);
                          setAutocompleteSelected(value);
                        }}
                        getOptionLabel={(option) =>
                          `${option.name} (${option.categoryPath})`
                        }
                        onInputChange={handleInputChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Kategori Ara"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                        disabled={Boolean(
                          (selectedMarketplaceCategories[
                            allPlaces[selectedTab]?.id
                          ]?.filter(
                            (item) => item.type === allPlaces[selectedTab]?.type
                          )[0]?.ecommercePlaceId ==
                            allPlaces[selectedTab]?.id ||
                            selectedMarketplaceCategories[
                              allPlaces[selectedTab]?.id
                            ]?.filter(
                              (item) =>
                                item.type === allPlaces[selectedTab]?.type
                            )[0]?.marketPlaceId ==
                              allPlaces[selectedTab]?.id) &&
                            allPlaces[selectedTab]?.type ==
                              selectedMarketplaceCategories[
                                allPlaces[selectedTab]?.id
                              ]?.filter(
                                (item) =>
                                  item.type === allPlaces[selectedTab]?.type
                              )[0]?.type
                        )}
                        renderOption={(props, option) => (
                          <li {...props}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span>{option.name}</span>
                              {option.categoryPath && (
                                <span
                                  style={{
                                    color: "rgba(0, 0, 0, 0.6)",
                                    fontSize: "0.875rem",
                                    lineHeight: 1.5,
                                  }}
                                >
                                  {option.categoryPath}
                                </span>
                              )}
                            </div>
                          </li>
                        )}
                      />
                    )}
                  </Box>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddCategory}
                    disabled={Boolean(
                      (selectedMarketplaceCategories[
                        allPlaces[selectedTab]?.id
                      ]?.filter(
                        (item) => item.type === allPlaces[selectedTab]?.type
                      )[0]?.ecommercePlaceId == allPlaces[selectedTab]?.id ||
                        selectedMarketplaceCategories[
                          allPlaces[selectedTab]?.id
                        ]?.filter(
                          (item) => item.type === allPlaces[selectedTab]?.type
                        )[0]?.marketPlaceId == allPlaces[selectedTab]?.id) &&
                        allPlaces[selectedTab]?.type ==
                          selectedMarketplaceCategories[
                            allPlaces[selectedTab]?.id
                          ]?.filter(
                            (item) => item.type === allPlaces[selectedTab]?.type
                          )[0]?.type
                    )}
                    fullWidth
                    sx={{
                      textTransform: "none",
                      fontWeight: "bold",
                      fontSize: { xs: "0.95rem", sm: "14px" },
                      padding: { xs: "8px 0", sm: "8px 16px" },
                      mt: { xs: 1, sm: 0 },
                    }}
                  >
                    Kategori Ekle
                  </Button>
                </Box>
              )}

              <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {selectedMarketplaceCategories[allPlaces[selectedTab]?.id]
                  ?.filter((item) => item.type === allPlaces[selectedTab]?.type)
                  ?.map((category) => (
                    <Chip
                      key={category.id}
                      label={category.name}
                      onDelete={() => handleDeleteCategory(category.originalId)}
                      color="primary"
                      sx={{
                        fontSize: { xs: "0.9rem", sm: "14px" },
                        padding: { xs: "6px", sm: "8px" },
                        backgroundColor: "secondary.light",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "secondary.main",
                        },
                      }}
                    />
                  ))}
              </Box>
            </>
          ) : (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ mt: 4 }}
            >
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  mb: 3,
                  fontSize: { xs: "1.1rem", sm: "1.25rem" },
                }}
              >
                Yeni Pazaryeri Eklemek İçin
              </Typography>

              <Button
                variant="contained"
                startIcon={<span>+</span>}
                sx={{
                  bgcolor: "#1E88E5",
                  borderRadius: 28,
                  px: 3,
                  py: 1,
                  color: "white",
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": {
                    bgcolor: "#1565C0",
                  },
                }}
                onClick={() => (window.location.href = "/Application")}
              >
                Ekle
              </Button>
            </Grid>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default CategoryMatchingModal;
